import { css } from '@emotion/react';

export const word = css`
  display: inline-block;
`;
